<div class="detalle-root" *ngIf="actividad as det">
  <div class="detalle-header">
    <div class="header-text">
      <h2>Detalle de la actividad grupal</h2>
      <p class="subtitulo">Información completa del registro seleccionado.</p>
    </div>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()" aria-label="Cerrar panel">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="detalle-content">
    <h3 class="titulo-principal">{{ det.nombre || 'Sin nombre' }}</h3>
    <span
      class="badge-estado"
      [ngClass]="getClaseEstado(det.estado) || 'estado-neutral'"
      *ngIf="det.estado">
      {{ det.estado }}
    </span>

    <div class="bloque-detalle">
      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="pricetag-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Categoría</span>
          <p class="valor">{{ textoCategoria(det) }}</p>
        </div>
      </div>

      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="person-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Asesor especialista</span>
          <p class="valor">{{ det.asesor?.trim() || '—' }}</p>
        </div>
      </div>

      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="book-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Temas</span>
          <ul class="lista-temas-valor" *ngIf="listaTemas.length > 0; else sinTemas">
            <li *ngFor="let tema of listaTemas">{{ tema }}</li>
          </ul>
          <ng-template #sinTemas><p class="valor">—</p></ng-template>
        </div>
      </div>

      <div class="campo-detalle" *ngIf="tieneDescribaOtro(det)">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="book-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Describa otro (Tema)</span>
          <p class="valor">{{ det.objetivo_otro || '—' }}</p>
        </div>
      </div>

      <ng-container *ngIf="det.fecha_inicio; else fechaHoraUnica">
        <div class="campo-detalle">
          <div class="icono-seccion" aria-hidden="true">
            <ion-icon name="calendar-outline"></ion-icon>
          </div>
          <div class="cuerpo-campo">
            <span class="etiqueta">Fecha Inicio</span>
            <p class="valor">{{ formatearFecha(det.fecha_inicio) }}</p>
          </div>
        </div>

        <div class="campo-detalle">
          <div class="icono-seccion" aria-hidden="true">
            <ion-icon name="calendar-outline"></ion-icon>
          </div>
          <div class="cuerpo-campo">
            <span class="etiqueta">Fecha Término</span>
            <p class="valor">{{ formatearFecha(det.fecha_termino || det.fecha) }}</p>
          </div>
        </div>
      </ng-container>

      <ng-template #fechaHoraUnica>
        <div class="campo-detalle">
          <div class="icono-seccion" aria-hidden="true">
            <ion-icon name="calendar-outline"></ion-icon>
          </div>
          <div class="cuerpo-campo">
            <span class="etiqueta">Fecha</span>
            <p class="valor">{{ formatearFecha(det.fecha) }}</p>
          </div>
        </div>
      </ng-template>

      <div class="campo-detalle" *ngIf="obtenerHoraProgramada(det) as horaProg">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="time-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Hora Programada</span>
          <p class="valor">{{ horaProg }}</p>
        </div>
      </div>

      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="location-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Lugar</span>
          <p class="valor">{{ det.lugar?.trim() || '—' }}</p>
        </div>
      </div>

      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="business-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Unidad operativa</span>
          <p class="valor">{{ nombreUnidadOperativa ?? '…' }}</p>
        </div>
      </div>

      <div class="campo-detalle campo-objetivos">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="flag-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Objetivos</span>
          <div class="bloque-objetivos">
            {{ det.objetivos?.trim() || '—' }}
          </div>
        </div>
      </div>

      <div class="campo-detalle">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="mail-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Notificar por correo a Ejecutivos/as</span>
          <p class="valor">{{ det.notificar_ejecutivos ? 'Sí' : 'No' }}</p>
        </div>
      </div>

      <div class="campo-detalle campo-asistencia" *ngIf="adjuntosDocumentacion.length > 0">
        <div class="icono-seccion" aria-hidden="true">
          <ion-icon name="document-attach-outline"></ion-icon>
        </div>
        <div class="cuerpo-campo">
          <span class="etiqueta">Documentación de evidencia</span>
          <div class="adjuntos-detalle-lista">
            <div class="adjunto-detalle-bloque" *ngFor="let item of adjuntosDocumentacion">
              <button
                type="button"
                class="btn-adjunto btn-adjunto-accion"
                [title]="'Ver o descargar: ' + item.adjunto.nombre_archivo"
                [attr.aria-label]="'Ver o descargar ' + item.etiqueta + ' ' + item.adjunto.nombre_archivo"
                (click)="abrirDocumento(item.adjunto)">
                <ion-icon name="eye-outline" class="btn-adjunto-icono" aria-hidden="true"></ion-icon>
                <span class="btn-adjunto-categoria-nombre">
                  <span class="btn-adjunto-badge">{{ item.badgeDetalle }}</span>
                  <span class="btn-adjunto-nombre">{{ item.adjunto.nombre_archivo }}</span>
                </span>
              </button>
              <p class="adjunto-fecha-subida" *ngIf="textoFechaSubida(item.adjunto) as fechaSub">
                Subido {{ fechaSub }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="detalle-footer">
    <ion-button expand="block" fill="outline" (click)="cerrar()">Cerrar</ion-button>
  </div>
</div>
